/* src/app/pages/refinamiento/recibirresultadosref/recibirresultadosref.component.scss */
/*# sourceMappingURL=recibirresultadosref.component.css.map */
